/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_TitleInputs */

const cs_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Týmový chat`)
};

const en_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat`)
};

/**
* | output |
* | --- |
* | "Team chat" |
*
* @param {Chat_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_title = /** @type {((inputs?: Chat_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_title(inputs)
	return cs_chat_title(inputs)
});